import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface NoStylistProps {
  noStylistMessage?: string;
}

const NoStylist: React.FC<NoStylistProps> = ({ noStylistMessage }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ mb: 2 }}>{noStylistMessage ||t('common.noStylistMessage')}</Box>
      <Button
        variant="contained"
        href={`${import.meta.env.VITE_BASE_URL}/stylist`}
      >
        {t('common.goToStylistPage')}
      </Button>
    </Box>
  );
};

export default NoStylist;
